var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropExcelIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5514_7274)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5514_7274",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.62939e-06H60V60H0V7.62939e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5514_7274)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 54.7266C0 57.6391 2.3611 60 5.27344 60H54.7266C57.6389 60 60 57.6391 60 54.7266V22.8516C60 21.8808 59.213 21.0938 58.2422 21.0938H1.75781C0.786999 21.0938 0 21.8808 0 22.8516V54.7266ZM5.27344 56.4844C4.30265 56.4844 3.51562 55.6974 3.51562 54.7266V24.6094H56.4844V54.7266C56.4844 55.6974 55.6973 56.4844 54.7266 56.4844H5.27344Z",
    fill: "#EA8C9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75781 24.6094C2.72863 24.6094 3.51562 23.8224 3.51562 22.8516V5.27344C3.51562 4.30261 4.30265 3.51562 5.27344 3.51562H15.9375C18.8499 3.51562 21.2109 5.87663 21.2109 8.78906C21.2109 9.75987 21.9979 10.5469 22.9687 10.5469H54.7266C55.6973 10.5469 56.4844 11.3339 56.4844 12.3047V22.8516C56.4844 23.8224 57.2714 24.6094 58.2422 24.6094C59.213 24.6094 60 23.8224 60 22.8516V12.3047C60 9.39216 57.6389 7.03125 54.7266 7.03125H24.5507C23.7364 3.01951 20.1896 0 15.9375 0H5.27344C2.3611 0 0 2.36091 0 5.27344V22.8516C0 23.8224 0.786999 24.6094 1.75781 24.6094Z",
    fill: "#EA8C9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.78906 24.6094C9.75988 24.6094 10.5469 23.8224 10.5469 22.8516V17.5781H49.4531V22.8516C49.4531 23.8224 50.2401 24.6094 51.2109 24.6094C52.1817 24.6094 52.9687 23.8224 52.9687 22.8516V15.8203C52.9687 14.8495 52.1817 14.0625 51.2109 14.0625H8.78906C7.81825 14.0625 7.03125 14.8495 7.03125 15.8203V22.8516C7.03125 23.8224 7.81825 24.6094 8.78906 24.6094Z",
    fill: "#EA8C9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7258 38.2742C22.4123 38.9607 23.5252 38.9607 24.2117 38.2742L30 32.4859L35.7883 38.2742C36.4748 38.9607 37.5877 38.9607 38.2742 38.2742C38.9607 37.5877 38.9607 36.4748 38.2742 35.7883L31.243 28.757C30.5565 28.0706 29.4435 28.0706 28.757 28.757L21.7258 35.7883C21.0393 36.4748 21.0393 37.5877 21.7258 38.2742Z",
    fill: "#EA8C9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 45.8203C30.9708 45.8203 31.7578 45.0333 31.7578 44.0625V30C31.7578 29.0292 30.9708 28.2422 30 28.2422C29.0292 28.2422 28.2422 29.0292 28.2422 30V44.0625C28.2422 45.0333 29.0292 45.8203 30 45.8203Z",
    fill: "#EA8C9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6953 51.0938C17.6953 52.0646 18.4823 52.8516 19.4531 52.8516H40.5469C41.5177 52.8516 42.3047 52.0646 42.3047 51.0938V47.5781C42.3047 46.6073 41.5177 45.8203 40.5469 45.8203C39.5761 45.8203 38.7891 46.6073 38.7891 47.5781V49.3359H21.2109V47.5781C21.2109 46.6073 20.4239 45.8203 19.4531 45.8203C18.4823 45.8203 17.6953 46.6073 17.6953 47.5781V51.0938Z",
    fill: "#EA8C9E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5514_7274"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropExcelIcon);
export default __webpack_public_path__ + "static/media/drop-excel-icon.5e7d1eee81a22db2f91ad803bb0251b4.svg";
export { ForwardRef as ReactComponent };